/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState} from 'react'
import styled from 'styled-components'
import { useParams } from "react-router-dom"
import db from "../firebase"


function Detail() {
    const { id } = useParams();
    const [ movie, setMovie ]  = useState({})
 
    useEffect(()  => {
        db.collection("movies").doc(id).get().then((doc) =>{
         if(doc.exists){
            setMovie(doc.data());
         } else {
           //redirect to home page
         }
       })
    }, [])




    return (
        <Container>
            <Background>
              <img src={movie.backgroundImg} />
            </Background>
            <ImageTitle>
                 <img src={movie.titleImg} />
            </ImageTitle>
            <Controls>
                <PlayButton>
                     <img src="/images/play-icon-black.png" />
                     <span>PLAY</span>
                </PlayButton>
                <TrailerButton>
                     <img src="/images/play-icon-white.png" />
                     <span>Trailer</span>
                </TrailerButton>
                <AddButton>
                  <span>+</span>
                </AddButton>
                <GroupWatchButton>
                    <img src="/images/group-icon.png" />
                </GroupWatchButton>
            </Controls>
            <SubTitles>
              {movie.subTitle}
            </SubTitles>
            <Description>
              {movie.description}
            </Description>
        </Container>
    )
}

export default Detail

const Container = styled.div`
   min-height: calc(100vh - 70px);
   padding: 0 calc(3.5vw + 5px);
   position: relative;

`
const Background = styled.div`
   position: fixed;
   top: 0;
   left: 0;
   bottom: 0;
   right: 0;
   z-index: -1;
   opacity: 0.8;

   img {
       width: 100%;
       height: 100%;
       object-fit: cover;
   }
`


const ImageTitle = styled.div`
  height: 30vh;
  min-height: 170px;
  min-width: 200px;
  width: 35vw;
  min-width: 200px;
  margin-top: 60px;


  img {
      width: 100%;
      height: 100%;
      object-fit: contain;
  }
`

const Controls = styled.div`
  display: flex;
  align-items: center;
`

const PlayButton = styled.button`
  border-radius: 4px;
  font-size: 15px;
  padding: 0px 24px;
  margin-right:  22px;
  display: flex;
  align-items: center;
  height: 56px;
  background: rgba(249, 249, 249);
  border: none;
  letter-spacing: 1.8px;
  cursor: pointer;

  &:hover {
      background: rgba(198, 198, 198);
      
  }
`

const TrailerButton = styled(PlayButton)`
  background: rgba(0, 0, 0, 0.3);
  border: 1px solid rgba(249, 249, 249);
  color: rgba(249, 249, 249);
  text-transform: uppercase;
`

const AddButton = styled.button`
   margin-right: 16px;
   width: 44px;
   height: 44px;
   display : flex;
   align-items : center;
   justify-content : center;
   border-radius : 50%;
   border: 2px solid white;
   background-color :rgba(0, 0, 0, 0.6);
   cursor: pointer;

   span {
     font-size: 30px;  
     color: white;
   }
`

const GroupWatchButton = styled(AddButton)`
   background: rgba(0, 0, 0);
`

const SubTitles = styled.div`
   color: rgba(249, 249, 249);
   min-height: 20px;
   margin-top: 26px;
`

const Description = styled.div`
  line-height: 1.4;
  font-size: 20px;
  margin-top: 16px;
  color: rgba(249, 249, 249);
  max-width: 760px;
`